// extracted by mini-css-extract-plugin
export var contentSwitcherTaskItem = "ContentSwitcherTaskItem-module--contentSwitcherTaskItem--2wYwe";
export var active = "ContentSwitcherTaskItem-module--active--2bgZI";
export var taskIcon = "ContentSwitcherTaskItem-module--taskIcon--1zGik";
export var taskContent = "ContentSwitcherTaskItem-module--taskContent--J5pNL";
export var rightContent = "ContentSwitcherTaskItem-module--rightContent--2aIgk";
export var retry = "ContentSwitcherTaskItem-module--retry--1gtJj";
export var score = "ContentSwitcherTaskItem-module--score--3FO3e";